import { memo, useMemo } from 'react'
import { Stack } from '@mui/material'
import MultiStrikeChartTypeMenu from '../../../../pages/home/openInterestHeader/MultiStrikeChartTypeMenu'
import { ChartViewKey, MULTI_STRIKE_MIN_BUCKET_SECONDS } from '../../../../assets/constants'
import TimeBuckets from '../../../timeBuckets/TimeBuckets'

type Props = {
    viewKey: string
}

const MultiStrikeMetadataWidgetControls = ({ viewKey }: Props) => {
    const isWidget = useMemo(() => viewKey !== ChartViewKey.MULTI_STRIKES_CHART, [viewKey])

    return (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ flexShrink: 0, flexWrap: 'nowrap' }}>
            <MultiStrikeChartTypeMenu viewKey={viewKey} isWidget={isWidget} compact />
            <TimeBuckets
                registerShortcut={false}
                viewKey={viewKey}
                minBucketSeconds={MULTI_STRIKE_MIN_BUCKET_SECONDS}
                showFavorites={false}
                buttonProps={{ sx: { margin: 0, padding: 0, minWidth: 28, flexShrink: 0 } }}
            />
        </Stack>
    )
}

export default memo(MultiStrikeMetadataWidgetControls)
